module.exports = __webpack_public_path__ + "static/img/9.b03d1c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/zh/9.png
// module id = +LXz
// module chunks = 0